import React, { useEffect } from 'react';
import { Outlet, useSearchParams, useLocation } from 'react-router-dom';
import AudioPlayerPage from '../pages/AudioPlayer';
import InstallSnackBar from '../component/InstallSnackBar';
import GetNotification from '../component/GetNotification/GetNotification';

export default function GlobalLayout() {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const referer_id = searchParams.get('referer_id');
    referer_id && localStorage.setItem('referer_id', referer_id);
  });

  return (
    <>
      <InstallSnackBar />
      <Outlet />
      <GetNotification />
      <AudioPlayerPage />
    </>
  );
}
